import React from 'react';

const ChatbotVisual = ({ className }) => (
    <img
        src={process.env.PUBLIC_URL + '/assets/features/chatbot-visual.svg'}
        alt="Personalized Study Plans"
        className={className}
    />
);

export default ChatbotVisual;
